import "./sign.scss";

const Sign = () => {
	return (
		<div className="sign">
			<h2 className="sign__name">Danny Carvajal</h2>
			<i className="fas fa-heart"></i>
		</div>
	);
};

export default Sign;
